import {
  AbsoluteCenter,
  Box,
  Divider,
  Flex,
  Grid,
  GridItem,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
  Tooltip,
  useColorModeValue
} from '@chakra-ui/react';
import i18next from 'i18next';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import useLongMachineSetting from '@/hook/useLongMachineSetting';

import { COMMON_WEB_PATH } from '../../../constant';
import { LANGUAGES_MENU } from '../../../i18n/config';
import { closeLanguagePop } from '../../../redux/action/member/memberAction';
import { t } from 'i18next';

const LanguagePage = () => {
  const website_language = window.web_language || [];

  const memberData = useSelector((state) => state.isMemberInfo);
  const { test } = memberData || {};

  const language_filter = useMemo(() => {
    return LANGUAGES_MENU?.filter((item) => {
      if (test == 1) {
        return item;
      } else {
        return website_language?.includes(item.value);
      }
    });
  }, [LANGUAGES_MENU, test, website_language]);
  const onClose = async () => {
    await dispatch(closeLanguagePop());
  };

  const dispatch = useDispatch();

  const { longMachinePaddingTop } = useLongMachineSetting();

  return (
    <Modal
      variant={`brandPrimary`}
      onClose={onClose}
      isOpen={true}
      motionPreset="slideInBottom"
      isCentered
    >
      <ModalOverlay />
      <ModalContent
        width={{
          md: '450px',
          base: '90%'
        }}
        minW={{
          base: '90%',
          md: '500px'
        }}
        height={{
          base: '520px'
        }}
        borderRadius={{
          base: 'common'
        }}
        borderTopRadius={{
          md: 'none'
        }}
        borderBottomRadius={{
          md: 'common'
        }}
        shadow="md"
        bgImage={`url(${COMMON_WEB_PATH}/blue-layout/lng/lng_background.png) !important`}
        bg={`url(${COMMON_WEB_PATH}/blue-layout/lng/lng_background.png) !important`}
        bgSize="100% 100% !important"
        bgPosition="center"
        pb="10px"
        pt="20px"
        px="20px"
        position="relative"
      >
        <Box
          zIndex={1}
          position="absolute"
          bgImage={`url('${COMMON_WEB_PATH}/blue-layout/bet-record/bet_record_close.png')`}
          bgSize="100% 100%"
          bgPos="center"
          w="120px"
          h="120px"
          top="-70px"
          right="-28px"
          cursor="pointer"
          onClick={onClose}
        ></Box>
        <Box
          bgImage={`url(${COMMON_WEB_PATH}/blue-layout/lng/lng_title.png)`}
          bgSize="100% 100%"
          bgPos="center"
          display={'flex'}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <Text fontSize="24px">{t('common.language')}</Text>
        </Box>
        <ModalBody
          // bgImage={`url(${COMMON_WEB_PATH}/theOne/lng/lng_background_inner.png)`}
          bgSize="100% 100%"
          bgPosition="center"
          bgRepeat="no-repeat"
          h={500}
          px="0"
          overflow="scroll"
        >
          <Grid
            templateColumns={{ base: 'repeat(1, minmax(0, 1fr))' }}
            as="section"
            display="grid"
            flexDirection={`column`}
            gap="10px"
            //borderRadius={`common`}
            py="8px"
            px="8px"
          >
            {language_filter?.map((item, index) => {
              return (
                <>
                  <GridItem>
                    <Box
                      onClick={async (event) => {
                        event.stopPropagation();
                        await i18next.changeLanguage(item.value);
                        localStorage.setItem('i18nextLng', item.value);
                        const targetPath = item.value;

                        window.location.assign('/' + targetPath);
                      }}
                      key={`${item.language}-${index}`}
                      cursor={`pointer`}
                      //borderRadius={`common`}
                      p="10px"
                      px="10px"
                      display="flex"
                      flexDirection={`row`}
                      alignItems={`center`}
                      justifyContent={`center`}
                      sx={{
                        bgColor:
                          i18next.language === item.value ? '#85E9FF' : '',
                        bgSize: '100%100%',
                        bgPos: 'center',
                        bgRepeat: 'no-repeat'
                      }}
                      position="relative"
                      gap="20px"
                    >
                      <Flex
                        alignItems={`center`}
                        justifyContent={'center'}
                        gap="15px"
                        w="100%"
                      >
                        <Flex
                          className="text-overflow"
                          flex={1}
                          alignItems={`center`}
                          justifyContent={'center'}
                          gap="5px"
                        >
                          <Tooltip label={item.text}>
                            <Text
                              className="text-overflow"
                              fontWeight={`medium`}
                              fontSize="32px"
                              color={
                                i18next.language === item.value
                                  ? '#003D58'
                                  : 'white'
                              }
                            >
                              {item.text}
                            </Text>
                          </Tooltip>
                        </Flex>
                      </Flex>
                    </Box>
                  </GridItem>
                  <Divider bg={'#85E9FF'} />
                </>
              );
            })}
          </Grid>
        </ModalBody>
        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default LanguagePage;
